import { useEffect, useState } from 'react';
import styles from './FifaPage.module.css';

import { useAllItemsQuery } from '../../store/api/item.api';
import { useGetUserByIdQuery } from '../../store/api/user.api';
import { useActivatePromoMutation } from '../../store/api/promo.api';


import { Header } from '../../components/Header/Header';
import { FormBtn } from '../../UI/FormBtn/FormBtn';
import { DataInput } from '../../UI/DataInput/DataInput';
import { BlueBtn } from '../../UI/BlueBtn/BlueBtn';


import { useDbUserId } from '../../hooks/useDbUserId';
import { useUserDataBlurHandler } from '../../hooks/useUserDataBlurHandler';

import checkboxIcon from '../../assets/checkbox-icon.svg';
import checkboxActiveIcon from '../../assets/checkboxActive-icon.svg';
import emailIcon from '../../assets/email-icon.svg';
import plusIcon from '../../assets/inputPlus-icon.svg';
import passwordIcon from '../../assets/pass-icon.svg';

export const FifaPage = () => {
	const [selectedType, setSelectedType] = useState('');
	const [haveAccount, setHaveAccount] = useState(null);
	const [selectedPlatform, setSelectedPlatform] = useState()
	const [selectedRegion, setSelectedRegion] = useState()

	const [activatePromo] = useActivatePromoMutation();

	const [checkbox, setCheckbox] = useState(true);

	const [userDataState, setUserDataState] = useState({});

	const { tgId, dbUserId } = useDbUserId();
	const { data: userData, refetch: userRefetch } = useGetUserByIdQuery(tgId);

	const { data: gamesData = [] } = useAllItemsQuery({
		schema: 'fifa',
		params: { type: 'game' }
	});

	const { data: donateData = [] } = useAllItemsQuery({
		schema: 'fifa',
		params: { type: 'donate' }
	});

	const [promo, setPromo] = useState({
			id: null,
			value: '',
			disc: null,
			success: false,
			message: '',
	})

	const selectedItem = [...gamesData, ...donateData].find(item =>
		item.title === selectedType &&
		item.Fifa_Platform?.title === selectedPlatform &&
		item.Fifa_Region?.title === selectedRegion
	);

	let finalPrice = selectedItem ? selectedItem.price : 0;

	if (promo.success) {
		finalPrice -= finalPrice / 100 * Number(promo.disc)
	}

	useEffect(() => {
		sessionStorage.setItem('schema', 'fifa');

		if (userData) {
			setUserDataState({
				email: userData.email || '',
				accountEmail: userData.accountEmail || '',
				accountPassword: userData.accountPassword || '',
			});
		}
	}, [userData]);



	const { handleBlur } = useUserDataBlurHandler({
		checkbox,
		dbUserId,
		userRefetch,
		setUserDataState
	});

	const handleInputChange = (fieldName, value) => {
		setUserDataState(prevState => ({
			...prevState,
			[fieldName]: value,
		}));
	};

	const handlePromoBlur = async (value) => {
		if (value.length > 0) {
			const res = await activatePromo({ code: value })
			const resMess = res?.error ? res?.error.data.message : res?.data.message;
			setPromo({
				...promo,
				id: res?.data?.promoId || null,
				disc: res?.data?.disc || null,
				success: res?.error ? false : true,
				message: resMess
			})
		}
	}

	const orderData = {
		price: finalPrice,
		inShopInfo: {
			email: userDataState.email,
			login: userDataState.accountEmail,
			password: userDataState.accountPassword,
		},
		itemId: selectedItem?.id,
		promoCodeId: promo.success ? promo.id : null,
	};

	const setDonate = new Set(donateData.map(d => d.title))
	const slicedDonate = Array.from(setDonate).slice(-2)


	return (
		<div className='main' style={{ marginBottom: 20 }}>
			<div
				className={styles.itemImg}
				style={{
					backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.9), transparent), url(https://image.api.playstation.com/vulcan/ap/rnd/202507/1617/545c2ee83dd7df16ebf1cdd6bcb039016658974439401189.png)`
				}}
			>
				<Header />
			</div>
			<div className='form'>
				<p>Игра</p>
				{[...new Set(gamesData.map(item => item.title))].map(title => (
					<FormBtn
						key={title}
						text={title}
						active={selectedType === title}
						onClick={() => {
							setSelectedType(title);
							setHaveAccount(null);      // сброс
							setSelectedPlatform(null); // сброс
							setSelectedRegion(null);   // сброс
						}}
					/>
				))}
				<p style={{margin: '10px 0'}}>Донат | FC Points</p>
				<div className={styles.donateBlock}>
					{[...setDonate].slice(0, -2).map(title => (
						<FormBtn
							key={title}
							text={title}
							active={selectedType === title}
							style={{margin: 0}}
							onClick={() => {
								setSelectedType(title);
								setHaveAccount(null);      // сброс
								setSelectedPlatform(null); // сброс
								setSelectedRegion(null);   // сброс
							}}
						/>
					))}
				</div>
				<div className={styles.fullGrid}>
						<FormBtn
							text={slicedDonate[0]}
							active={selectedType === slicedDonate[0]}
							style={{margin: 0}}
							onClick={() => {
								setSelectedType(slicedDonate[0]);
								setHaveAccount(null);      // сброс
								setSelectedPlatform(null); // сброс
								setSelectedRegion(null);   // сброс
							}}
						/>
						<FormBtn
							text={slicedDonate[1]}
							active={selectedType === slicedDonate[1]}
							style={{margin: 0}}
							onClick={() => {
								setSelectedType(slicedDonate[1]);
								setHaveAccount(null);      // сброс
								setSelectedPlatform(null); // сброс
								setSelectedRegion(null);   // сброс
							}}
						/>
					</div>
			</div>

			{
				selectedType && (
					<div className='form'>
						<FormBtn
							text={'На мой личный аккаунт'}
							active={haveAccount}
							onClick={() => {
								setHaveAccount(true)
							}}
						/>
						<FormBtn
							text={'На новый аккаунт'}
							active={haveAccount === false}
							onClick={() => {
								setHaveAccount(false)
							}}
						/>
					</div>
				)
			}

			{
				haveAccount !== null && selectedType && (
					<div className="form">
						{[...new Set(
							[...gamesData, ...donateData]  // берём оба массива
								.filter(item => item.title === selectedType) // оставляем только выбранное
								.map(item => item.Fifa_Platform?.title) // берём название платформы (если есть include)
						)].map(platformTitle => (
							<FormBtn
								key={platformTitle}
								text={platformTitle}
								active={selectedPlatform === platformTitle}
								onClick={() => {
									setSelectedPlatform(platformTitle)
									setSelectedRegion()
								}}
							/>
						))}
					</div>
				)
			}

			{
				selectedPlatform && (
					<div className="form">
						<div className={styles.regionBlock}>
							{[...new Set(
							[...gamesData, ...donateData]
								.filter(item => item.title === selectedType && item.Fifa_Platform?.title === selectedPlatform)
								.map(item => item.Fifa_Region?.title) // берем название региона
						)].map(regionTitle => (
							<FormBtn
								key={regionTitle}
								text={regionTitle}
								style={{margin: 0}}
								active={selectedRegion === regionTitle}
								onClick={() => setSelectedRegion(regionTitle)}
							/>
						))}
						</div>
					</div>
				)
			}

			{
				selectedRegion && (
					<>
						<div className='form'>
							{
								haveAccount ?
									<>
										<p>Данные аккаунта</p>
										<DataInput
											name="email"
											text={'E-mail'}
											type={'email'}
											img={emailIcon}
											value={userDataState.accountEmail}
											onChange={value => handleInputChange("accountEmail", value)}
											onBlur={value => handleBlur("accountEmail", value)}
										/>
										<DataInput
											name="password"
											text={'Пароль'}
											type={'password'}
											img={passwordIcon}
											value={userDataState.accountPassword}
											onChange={value => handleInputChange("accountPassword", value)}
											onBlur={value => handleBlur("accountPassword", value)}
										/>
										<DataInput
											name="email"
											text={'Почта для чека'}
											img={plusIcon}
											type={'email'}
											value={userDataState.email}
											onChange={value => handleInputChange("email", value)}
											onBlur={value => handleBlur("email", value)}
										/>
									</>
									:
									<>
										<p>Бот бесплатно создаст для вас новый аккаунт</p>
										<DataInput
											name="email"
											text={'Почта для чека'}
											img={plusIcon}
											type={'email'}
											value={userDataState.email}
											onChange={value => handleInputChange("email", value)}
											onBlur={value => handleBlur("email", value)}
										/>
									</>
							}
							<div className={styles.formLine}></div>
							<div className={styles.checkbox} onClick={() => setCheckbox(!checkbox)}>
								{checkbox ? (
									<img src={checkboxActiveIcon} alt="checkboxActiveIcon" />
								) : (
									<img src={checkboxIcon} alt="checkboxIcon" />
								)}
								<span>Запомнить данные</span>
							</div>
						</div>
						<div className="form">
							<p>Используйте промокод</p>
							{
								promo.message.length > 0 &&
								<p style={promo.success ? { marginTop: 10, color: "green" } : { marginTop: 10, color: "red" }}>{promo.message}</p>
							}

							<DataInput
								name="promo"
								text={'Промокод'}
								img={plusIcon}
								type={'text'}
								value={promo.value}
								onChange={value => setPromo({ ...promo, value })}
								onBlur={value => handlePromoBlur(value)}
							/>
						</div>

					</>
				)
			}

			<div className={styles.priceBlock}>
				{selectedItem && (
					<>
					{
							(selectedItem.price_disc || promo.success) &&
							<p className={styles.price_amount}>{selectedItem.price} ₽</p>
					}
						<h2 style={selectedItem.price_disc || promo.success ? { color: '#FF0044' } : {}}>{finalPrice} ₽</h2>
					</>
				)}
			</div>
			{
				selectedItem && (
					<div className={styles.btn}>
						<BlueBtn
							type='pay'
							text='Купить'
							orderData={orderData}
							activeBtnOrder={haveAccount ? 1 : 2}
						/>
					</div>
				)
			}
		</div>
	);
};
